import '../style.scss';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { IconName, findIcon } from 'utils/handleIcon';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { PagePath } from 'constants/pagePath';
import { useNavigate } from 'react-router-dom';
import { CompatibilityCheckProps } from '../..';

export const QuestionCompletePage = (props: CompatibilityCheckProps) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="compatibilityCheck">
        <div className="compatibilityCheck_descriptionWrapper">
          <Description
            label="ご回答いただき、誠にありがとうございました。"
            labelColor={labelColor.black}
            labelSize={labelSize.massive}
          />
        </div>
        <Button
          label={props.completedNextPage ? props.completedNextPage.label : 'HOMEに戻る'}
          buttonFill={ButtonFill.link}
          buttonSize={ButtonSize.extraLarge}
          onClick={() => (props.completedNextPage ? props.completedNextPage.navigate() : navigate(PagePath.Home))}
        />
      </div>
    </>
  );
};
